var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 40,
    r: 40,
    fill: "#30444E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inner-circle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0988 72.1975C49.6119 72.1975 57.7763 68.8157 63.796 62.796C69.8157 56.7763 73.1975 48.6119 73.1975 40.0988C73.1975 31.5856 69.8157 23.4212 63.796 17.4015C57.7763 11.3818 49.6119 8 41.0988 8C32.5856 8 24.4212 11.3818 18.4015 17.4015C12.3818 23.4212 9 31.5856 9 40.0988C9 48.6119 12.3818 56.7763 18.4015 62.796C24.4212 68.8157 32.5856 72.1975 41.0988 72.1975ZM29.1979 31.6978C29.1979 29.2125 31.2126 27.1978 33.6979 27.1978C36.1832 27.1978 38.1979 29.2125 38.1979 31.6978V48.6978C38.1979 51.183 36.1832 53.1978 33.6979 53.1978C31.2126 53.1978 29.1979 51.183 29.1979 48.6978V31.6978ZM48.6979 27.1978C46.2126 27.1978 44.1979 29.2125 44.1979 31.6978V48.6978C44.1979 51.183 46.2126 53.1978 48.6979 53.1978C51.1832 53.1978 53.1979 51.183 53.1979 48.6978V31.6978C53.1979 29.2125 51.1832 27.1978 48.6979 27.1978Z",
    fill: "#F97953"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pause.7e11c8b4489ac0c90032ffed6ba34023.svg";